export type OdontogramImageCategory =
  | "RX_PANORAMICA"
  | "RX_PERIAPICAL"
  | "RX_BITEWING"
  | "FOTO_INTRAORAL"
  | "FOTO_EXTRAORAL"
  | "HISTORIA_CLINICA"
  | "DOCUMENTO"
  | "OTRO";

/** Orden fijo de despliegue de categorías (coincide con el enum de Prisma). */
export const ODONTOGRAM_IMAGE_CATEGORIES: OdontogramImageCategory[] = [
  "RX_PANORAMICA",
  "RX_PERIAPICAL",
  "RX_BITEWING",
  "FOTO_INTRAORAL",
  "FOTO_EXTRAORAL",
  "HISTORIA_CLINICA",
  "DOCUMENTO",
  "OTRO",
];

export const ODONTOGRAM_IMAGE_CATEGORY_LABELS: Record<OdontogramImageCategory, string> = {
  RX_PANORAMICA: "Radiografía panorámica",
  RX_PERIAPICAL: "Radiografía periapical",
  RX_BITEWING: "Radiografía bitewing",
  FOTO_INTRAORAL: "Foto intraoral",
  FOTO_EXTRAORAL: "Foto extraoral",
  HISTORIA_CLINICA: "Historia clínica",
  DOCUMENTO: "Documento",
  OTRO: "Otro",
};

export type OdontogramImage = {
  id: string;
  professionalId: string;
  clientId: string;
  consultId: string | null;
  category: OdontogramImageCategory;
  cloudinaryUrl: string;
  cloudinaryId: string;
  filename: string | null;
  notes: string | null;
  takenAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export function isPdfImage(img: Pick<OdontogramImage, "cloudinaryUrl" | "filename">): boolean {
  const name = img.filename ?? img.cloudinaryUrl;
  return name.toLowerCase().endsWith(".pdf");
}
